module.exports = __webpack_public_path__ + "static/red_hat_logo-d4f955a5ec29f95d1b772cdd3c9637e9.png";